<template>
  <div class="h-fill">
    <template v-if="!$parent.appInner && openFromAppInner && purchasedCard">
      <div class="display-flex justify-content-center pd-t-80">
        <div class="text-align-center">
          <div>
            <van-icon name="checked" class="c-app-green fs-100"/>
          </div>
          <div>
            支付成功，请返回APP下载资源！
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="card.createAt">
      <div style="z-index: 999" :class="mScrollY > 1 ? 'shadow-2':''" class="bg-f position-fixed t-0 l-0 r-0">
        <div class="justify-content-space-between align-items-center pd-t-5 pd-r-15 pd-b-5">
          <div v-if="$parent.appInner" class="c-app-green" @click="onBackClick">
            首页
          </div>
          <div v-else @click="onBackClick">
            <van-icon name="arrow-left"/>
          </div>
          <div class="align-items-center fs-12 c-9">
            <div class="c-app-green" @click="onBuyKnowClick">购买必读</div>
            <div class="mg-l-5 mg-r-5">|</div>
            <div @click="onShareClick">分享</div>
            <div class="mg-l-5 mg-r-5">|</div>
            <!--<div v-if="!$parent.appInner || $parent.isAndroid" class="mg-l-5 mg-r-5">|</div>-->
            <div @click="onReportClick">举报</div>
            <div v-if="card.teamInfo.length > 0" @click="onTeamRuleClick">
              <span class="mg-l-5 mg-r-5">|</span>
              <span>拼团规则</span>
            </div>
          </div>
        </div>
      </div>
      <div class="pd-15 mg-t-25">
        <div class="justify-content-space-between ">
          <div class="fs-22 flex-1 lh-28">
          <span v-if="card.mark" class="pd-l-6 pd-r-6 display-inline-block lh-22 h-22 bdr-2 fs-12 mg-r-5"
                style="background: linear-gradient(51deg, #262626 0%, #545454 100%);color: #FFC680;vertical-align: middle;"
          >{{ card.mark }}</span>
            <span class="text-strong" style="vertical-align: middle;">{{ card.title }}</span>
          </div>
          <div class="w-100 fs-12 c-app-green text-align-right mg-t-4 text-strong">
            {{ card.levelName }} / {{ card.subjectName }}
          </div>
        </div>

        <div class="justify-content-space-between mg-t-10">
          <div class="align-items-center fs-12">
            <!--            <img class="mg-r-5" width="18" src="/h5/static/images/resource-icon.png"/>-->
            <div class="c-app-orange fs-14" v-if="card.price > 0">
              <template v-if="$parent.isIos && $parent.appInner">{{ card.price / 100 }}学习币</template>
              <template v-else>￥ {{ card.price / 100 }}</template>
            </div>
            <div class="mg-l-5 mg-r-5">|</div>
            <div>大小 {{ formatFileSize }}</div>
            <div class="mg-l-5 mg-r-5">|</div>
            <template v-if="card.cardCount > -1">
              <div>卡片 {{ card.cardCount }}</div>
            </template>

            <div class="c-app-orange" v-else>免费</div>
          </div>
          <div class="align-items-center fs-12 c-9">
            <div>{{ card.hotValue }}</div>
          </div>
        </div>
        <div class="display-flex fs-12 align-items-center justify-content-space-between mg-t-10">
          <div class="fs-12 c-9 mg-b-5">
            更新于：{{ card.editAt ? card.editAt : card.createAt }}
          </div>
          <div class="display-flex flex-wrap">
            <div v-for="tag,index in card.tags" :key="tag.tagId"
                 class="bg-f3f pd-l-5 pd-r-5 pd-t-2 pd-b-2 bdr-2 mg-l-5 mg-b-5 nowap">{{ tag.tagName }}
            </div>
          </div>
        </div>
        <div class="h-1 mg-t-15" style="border-bottom: 1px #ccc dashed"></div>
        <div class="justify-content-space-between mg-t-10">
          <div class="c-7">
            <div v-if="!card.scoreNew" class="text-align-center fs-14">
              <div v-if="card.evaluateUserCount > 5">
                <div>{{ card.score }} 评分</div>
                <!--<div class="fs-12 c-9 mg-t-2">{{card.evaluateUserCount}}人评分</div>-->
              </div>
              <div v-else class="c-9">
                累计中
              </div>
              <div v-if="card.evaluateUserCount >= 5" class="mg-t-4 mg-l-4">
                <van-rate size="14" allow-half v-model="card.score" color="#FFB904" readonly/>
              </div>
              <div v-else class="mg-t-4 mg-l-4">
                <van-rate size="14" allow-half color="#cccccc" readonly/>
              </div>
            </div>
            <div v-else class="fs-12">
              <div class="pd-b-5">
                <div class="display-inline-block mg-r-5">内容质量</div>
                <van-rate size="14" allow-half v-model="card.qualityScore" color="#FFB904" readonly/>
                <div class="display-inline-block mg-l-5">{{card.qualityScore}}</div>
              </div>
              <div class="pd-b-5">
                <div class="display-inline-block mg-r-5">界面美观</div>
                <van-rate size="14" allow-half v-model="card.uiScore" color="#FFB904" readonly/>
                <div class="display-inline-block mg-l-5">{{card.uiScore}}</div>
              </div>
              <div>
                <div class="display-inline-block mg-r-5">售后服务</div>
                <van-rate size="14" allow-half v-model="card.afterSalesScore" color="#FFB904" readonly/>
                <div class="display-inline-block mg-l-5">{{card.afterSalesScore}}</div>
              </div>
            </div>
          </div>
          <div class="align-items-center">
            <div>
              <div class="pd-8 fs-12 pd-r-20 pd-l-20 bg-app-orange c-f bdr-4" @click="subScore">评分</div>
              <van-popup v-model="showScore" round closeable style="width: 75%">
                <div class="bg-f pd-20">
                  <div class="fs-18 mg-t-20">
                    <div class="pd-b-20 mg-l-10">
                      <div class="mg-r-5 display-inline-block">资源内容质量</div>
                      <van-rate size="18" v-model="score.quality_score" color="#FFB904"/>
                    </div>
                    <div class="pd-b-20 mg-l-10">
                      <div class="display-inline-block mg-r-5">卡片界面美观</div>
                      <van-rate size="18" v-model="score.ui_score" color="#FFB904"/>
                    </div>
                    <div class="pd-b-20 mg-l-10">
                      <div class="display-inline-block">作者提供售后</div>
                      <div class="display-inline-block">
                        <van-radio-group v-model="score.is_after_sales" class="align-items-center">
                          <van-radio class="mg-l-6 mg-r-15" name="1">是</van-radio>
                          <van-radio name="2">否</van-radio>
                        </van-radio-group>
                      </div>
                    </div>
                    <div class="pd-b-20 mg-l-10" v-if="score.is_after_sales==1">
                      <div class="display-inline-block mg-r-5">作者售后服务</div>
                      <van-rate size="18" v-model="score.after_sales_score" color="#FFB904"/>
                    </div>
                    <van-field
                        class="fs-16"
                        type="textarea"
                        v-model="score.score_content"
                        placeholder="说点什么吧"
                        rows="3"
                        border
                        autosize
                        maxlength="50"
                        show-word-limit
                    />
                    <div class="pd-8 pd-r-20 pd-l-20 bg-app-orange text-align-center c-f bdr-4"
                         @click="saveScore">
                      评价
                    </div>
                  </div>
                </div>
              </van-popup>
            </div>

            <!--<div v-if="card.cardId && !card.evaluated" class="align-items-center fs-12">
              <div class="border-1 c-app-green bdc-app-green w-55 lh-22 text-align-center bdr-4"
                   @click="onEvaluateClick(2)">不推荐
              </div>
              <div class="mg-l-10 c-f bg-app-green w-55 lh-24 text-align-center bdr-4" @click="onEvaluateClick(1)">推荐
              </div>
            </div>
            -->
          </div>
        </div>
        <div class="h-1 bg-f3f mg-t-10 mg-b-10"></div>
        <div @click="onUserClick" class="justify-content-space-between align-items-center bg-f"
             style="border-top-left-radius: 10px;border-top-right-radius: 10px;">
          <div class="align-items-center">
            <img :src="userAvatar" class="w-30 h-30 bdr-circular border-2 bdc-e"/>
            <div class="fs-14 mg-l-10">{{ userNickname }}</div>
          </div>
          <div class="fs-12 c-9">
            查看作者主页
            <van-icon name="arrow"/>
          </div>
        </div>
      </div>
      <!--下载过或者购买过-->
      <div class="h-22 bg-f3f fs-12 c-c justify-content-center align-items-center">—— 资源详情 ——</div>
      <template v-if="underwayList.length > 0">
        <div class="justify-content-space-between align-items-center pd-l-15 pd-r-15 fs-12"
             style="border-bottom: 1px #e8e8e8 solid">
          <div><span class="c-app-red">{{ underwayUsers }}</span>人在拼团，可直接参与</div>
          <div class="c-9 pd-t-10 pd-b-10" @click="showAllUnderwayList = true">查看全部&gt;</div>
        </div>
        <div class="justify-content-space-between fs-12 pd-15">
          <div class="align-items-center">
            <img :src="underwayList[randomUnderwayIndex].avatar" class="w-30 h-30 bdr-circular mg-r-10"/>
            <div>
              {{ underwayList[randomUnderwayIndex].nickname }}
            </div>
          </div>
          <div class="align-items-center">
            <div class="mg-r-10">
              <div class="text-align-right">还差<span
                  class="c-app-red">{{ underwayList[randomUnderwayIndex].quota }}</span>人
              </div>
              <div>剩余 {{ underwayList[randomUnderwayIndex].countDownTxt }}</div>
            </div>
            <div class="bg-app-orange c-f bdr-5 pd-5" @click="onUnderwayTeamClick(underwayList[randomUnderwayIndex])">
              去拼团
            </div>
          </div>
        </div>
        <div class="h-10 bg-f3f"></div>
      </template>
      <div class="bg-f3f">
        <div class="fs-12 pd-10  bg-f" style="border-top-left-radius: 10px;border-top-right-radius: 10px;">

        </div>
      </div>
      <div class="pd-b-15 pd-l-15 pd-r-15">
        <template v-if="card.contact.length > 5">
          <div
              v-if="(card.price > 0 && card.purchased) || (card.price === 0 && card.downloadTimes > 0) || card.owner"
              class="pd-10  fs-14 bg-f3f bdr-5">
            <div v-if="card.purchased && card.purchasedExpiredDate !== null" class="c-app-red mg-b-10">
              <template v-if="!purchasedExpired">
                您已获得此资源，获得更新有效期至<b>{{ card.purchasedExpiredDate }}</b> <a class="c-app-blue" @click="showPurchasedExpiredExplain = true">点此查看说明</a>
              </template>
              <template v-else>
                您的资源更新有效期已过，只能下载作者在<b>{{ card.purchasedExpiredDate }}</b>之前发布的版本，如需续期请联系作者 <a class="c-app-blue" @click="showPurchasedExpiredExplain = true">点此查看说明</a>
              </template>
            </div>
            <div>
              作者联系方式：{{ card.contact }}
            </div>
          </div>
          <div v-else class="pd-8 fs-14 bg-f9f bdr-5 c-app-green text-align-center">
            <van-icon name="closed-eye"/>
            作者提供售后联系方式，购买后可见
          </div>
        </template>
        <!--tap页-->
        <van-tabs v-model="active" color="#28BEA0" title-active-color="#28BEA0" @click="onTabClick">
          <van-tab title="介绍" key=0>
            <div class="mg-t-10 card-content" style="min-height: 100px" v-if="card.content"
                 v-html="card.content"></div>
            <div class="mg-t-10 fs-14 c-9 text-align-center lh-60" v-if="card.cardId && !card.content">暂无介绍</div>
          </van-tab>
          <van-tab title="目录" class="text-strong" key=1>
            <div v-if="allDecks">
              <deck-item class="mg-t-20" :decks="allDecks" :activedid="activeDid"></deck-item>
            </div>
            <div class="mg-t-20 c-9 fs-14 text-align-center lh-60" v-else>
              暂无目录
            </div>
          </van-tab>
          <van-tab title="预览" key=2>
            <van-popup v-if="isPreview" v-model="isPreview" closeable round
                       position="bottom"
                       :style="{ height: '90%' }">
              <card-viewer :did="preview.cardList[0].did"
                           :cardId="card.cardId"
                           @previewClose="previewClose"
                           :isPreview="isPreview"
                           :cardList="preview.cardList"
                           :currentCardIndex="currentCardIndex"
                           :currentEditCard="currentEditCard"
              ></card-viewer>
            </van-popup>
            <div class="mg-t-20 c-9 fs-14 text-align-center lh-60" v-else>
              暂无预览
            </div>
          </van-tab>
        </van-tabs>
      </div>
      <div class="h-1 bg-d"></div>
      <div id="buyKnow">
        <div v-if="card.free != 1" class="fs-14 mg-15">
          <van-icon name="warning-o" color="#51C027"/>
          购买权益：本资源购买后永久支持下载
          <span v-if="card.subscribeDate == '1year'">，1年更新支持</span>
          <span v-else-if="card.subscribeDate == '2year'">，2年更新支持</span>
          <span v-else-if="card.subscribeDate == '3year'">，3年更新支持</span>
          <span v-else-if="card.subscribeDate == '3month'">，3个月更新支持</span>
          <span v-else-if="card.subscribeDate == '6month'">，6个月更新支持</span>
          <span v-else-if="card.subscribeDate">，{{ card.subscribeDate }}前更新支持</span>
          <span v-else>，永久更新支持</span>。如有其他疑问可购买后通过售后联系方式联系作者
        </div>
        <div v-if="card.free != 1" class="fs-14 mg-15">
          <van-icon name="warning-o" color="#51C027"/>
          使用说明：使用资源时会进行设备和IP检测，仅限您本人使用，请勿与他人合用资源避免出现无法使用的问题。
        </div>
        <div class="fs-14 mg-15">
          <van-icon name="warning-o" color="#51C027"/>
          退款说明：若您是付费购买此资源，由于虚拟产品的特殊性不支持无理由退款，商品质量问题2天内可向平台客服申请退款，逾期请联系作者提供售后自行协商沟通。
        </div>
        <div class="fs-14 mg-15">
          <van-icon name="warning-o" color="#51C027"/>
          版权声明：本APP【资源商店】模块只作为资源分发平台全部资源均由用户制作，平台不参与售卖以及不存在任何抽成盈利行为，用户上传时已签《版权责任承诺书》自行承担版权责任，若此资源侵犯了知识产权且您是版权方请发送反馈信件至<strong>ankichinas@163.com</strong>联系平台，感谢理解！
        </div>
      </div>
      <div class="pd-b-100">
        <div v-if="userOther.length > 0">
          <div class="pd-20 bg-f3f c-app-green text-strong">作者其他资源</div>
          <div v-for="item in userOther" style="border-bottom: 1px #eeeeee solid">
            <card-item :card="item"></card-item>
          </div>
        </div>
        <div v-if="recommend.length > 0">
          <div class="pd-20 bg-f3f c-app-green text-strong">平台其他资源</div>
          <div v-for="item in recommend" style="border-bottom: 1px #eeeeee solid">
            <card-item :card="item"></card-item>
          </div>
        </div>
      </div>
      <div class="position-fixed b-0 w-fill bg-f safe-bottom" style="border-top: #f3f3f3 1px solid;">
        <!--        <div v-if="card.vipDiscountEnable" class="text-strong">
                  <div class="arrow-div pd-t-10 pd-b-10 pd-l-5 pd-r-15 text-align-right" style="font-size: 12px;"
                       v-if="!card.isForeverVip && !card.isVip">
                    <img style="vertical-align: middle" src="/h5/static/images/super_heroes_normal@3x.png" height="18">
                    <span style="vertical-align: middle">
                      超级学霸全平台付费资源最低享<span class="c-app-orange text-strong">{{ card.vipYjDiscount }}折</span>
                      <span v-if="card.vipSaveMoney>500">，此资源预计省
                        <span class="c-app-orange text-strong">
                          {{
                            (card.vipSaveMoney) / 100
                          }}元
                        </span>
                      </span>
                    </span>
                  </div>
                  <div v-if="card.isVip" class="pd-t-10 pd-b-5 pd-l-5 pd-r-15"
                       style="font-size: 12px">
                    <img style="vertical-align: middle" src="/h5/static/images/super_heroes_normal@3x.png" height="18">
                    <span style="vertical-align: middle">
                      您已开通超级学霸，已享
                      <span v-if="card.isForeverVip" class="c-app-orange text-strong">
                            {{
                          card.vipYjDiscount
                        }}折
                      </span>
                      <span v-else class="c-app-orange text-strong">
                            {{
                          card.vipTempDiscount
                        }}折
                      </span>
                    </span>
                  </div>
                </div>-->
        <div v-if="card.deleted === 1">
          <div class="bg-app-red text-align-center lh-50 c-f flex-1">该资源已被删除</div>
        </div>
        <div v-else-if="card.status === 2 || card.status === 3">
          <div class="bg-app-red text-align-center lh-50 c-f flex-1">该资源已下架</div>
        </div>
        <div v-else-if="team && team.status == 1">
          <div @click="onTeamDetailClick" class="bg-app-orange text-align-center lh-60 c-f flex-1">
            查看拼团（{{ team.payCount }}/{{ team.users }}）
          </div>
        </div>
        <div v-else class="display-flex align-items-center">
          <div
              v-if="!card.owner && card.free != 1 && !card.purchased && card.hasCode && (!$parent.appInner || !$parent.isIos)"
              class="pd-l-15 pd-r-15 fs-14 c-app-green lh-60" @click="onInputExchangeCodeClick"
              style="background-color: #CCFFF0">兑换码
          </div>
          <div v-if="!purchasedCard && unSupportPlatform()" class="bg-a text-align-center lh-60 c-f flex-1">
            此卡牌暂不支持该系统
          </div>
          <template v-else-if="!purchasedCard && card.price > 0">
            <div v-if="card.teamInfo.length > 0" class="flex-1 display-flex align-items-center">
              <div class="flex-2 bg-app-green align-items-center justify-content-center c-f h-60"
                   @click="onDownloadClick">
                <div>
                  <div class="text-align-center">
                    <span v-if="$parent.isIos && $parent.appInner">{{ card.vipPrice / 100 }}学习币</span>
                    <span v-else>￥ {{ card.vipPrice / 100 }}</span>
                  </div>
                  <div class="fs-12 text-align-center">立即购买</div>
                </div>
              </div>
              <div class="flex-2 bg-app-orange align-items-center justify-content-center c-f h-60"
                   @click="onTeamOrderClick">
                <div>
                  <div class="text-align-center">
                      <span v-if="$parent.isIos && $parent.appInner">  {{
                          card.teamInfo[0]['vipPrice'] / 100
                        }}学习币</span>
                    <span v-else>  ￥ {{ card.teamInfo[0]['vipPrice'] / 100 }}</span>
                  </div>
                  <div class="fs-12 text-align-center">发起拼团</div>
                </div>
              </div>
            </div>
            <div v-else class="bg-app-orange text-align-center lh-60 c-f flex-1"
                 @click="onDownloadClick">
              <div>
                <span v-if="$parent.isIos && $parent.appInner">{{ card.vipPrice / 100 }}学习币购买</span>
                <span v-else>￥ {{ card.vipPrice / 100 }}购买</span>
              </div>
            </div>
          </template>
          <template v-else>

            <template v-if="!$parent.appInner">
              <div class="bg-app-green text-align-center h-60 c-f flex-1 pd-t-10" @click="onImportAnkiClick">
                导入至Anki<br>
                <span class="fs-10">下载文件后导入</span>
              </div>
              <div class="bg-app-orange text-align-center h-60 c-f flex-1 pd-t-10"
                   @click="onDownloadClick(true)">
                导入至Anymo<br>
                <span class="fs-10">一键导入(推荐)</span>
              </div>
            </template>
            <template v-else>
              <div class="bg-app-green text-align-center lh-60 c-f flex-1"
                   @click="onDownloadClick()">
                下载导入
              </div>
            </template>
          </template>
        </div>
      </div>

      <van-dialog v-model="showBuyKnow">
        <div v-html="buyKnowHtml"></div>
      </van-dialog>
      <van-dialog v-model="showPurchasedExpiredExplain" title="更新有效期说明" show-cancel-button confirmButtonText="知道了">
        <div class="pd-20 fs-14 lh-22">
          在 {{ card.purchasedExpiredDate }} 之前若作者更新了此资源您可以进行下载更新，若作者于此日期之后更新的卡片您无法下载，只能下载更新日期前的旧版本。如对此规则有疑问请联系作者
        </div>
      </van-dialog>
      <van-dialog v-model="showPayResult" title="支付提示" show-cancel-button confirmButtonText="已支付"
                  cancelButtonText="未支付" @confirm="onPayConfirm" @cancel="onPayCancel">
        <div class="mg-20">
          <div class="text-align-center">是否已支付完成？</div>
          <div v-if="$parent.appInner && copyPayUrl" class="c-app-red fs-14 mg-t-20">正在发起支付，若无反应请复制链接到浏览器打开<span
              class="c-app-blue"
              @click="onCopyPayUrlClick">点我复制链接</span>
          </div>
        </div>
      </van-dialog>
      <van-dialog v-model="showPublishNotice" title="发布资源" show-cancel-button confirmButtonText="确定">
        <div class="mg-20">
          <div class="text-align-center">
            抱歉移动端未适配，如需更好的展示效果请使用电脑浏览器访问【Anki中文资源网】file.ankichinas.cn 进行发布操作
          </div>
        </div>
      </van-dialog>
      <van-dialog v-model="showInputExchangeCode" title="使用兑换码获取" show-cancel-button confirmButtonText="确定"
                  @confirm="onConfirmExchangeClick">
        <div class="mg-20">
          <van-field v-model="exchangeCode" placeholder="请输入兑换码"/>
        </div>
      </van-dialog>
      <van-popup v-model="showAllUnderwayList" :close-on-click-overlay="false">
        <div class="w-350">
          <div class="bg-f pd-10 bdr-10">
            <div class="text-align-center fs-14">全部拼团</div>
            <div class="" style="max-height: 500px;overflow-y: scroll">
              <div v-for="item in underwayList" class="justify-content-space-between fs-12 pd-15 "
                   style="border-bottom: 1px solid #e8e8e8">
                <div class="align-items-center">
                  <img :src="item.avatar" class="w-30 h-30 bdr-circular mg-r-10"/>
                  <div>
                    {{ item.nickname }}
                  </div>
                </div>
                <div class="align-items-center">
                  <div class="mg-r-10">
                    <div class="text-align-right">还差<span class="c-app-red">{{ item.quota }}</span>人</div>
                    <div>剩余 {{ item.countDownTxt }}</div>
                  </div>
                  <div @click="onUnderwayTeamClick(team)" class="bg-app-orange c-f bdr-5 pd-5">
                    去拼团
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-align-center">
            <span @click="showAllUnderwayList = false"
                  class="display-inline-block mg-t-20 border-1 bdc-f bdr-circular w-20 lh-20 c-f">×</span>
          </div>
        </div>
      </van-popup>
    </template>
    <van-action-sheet
        v-model="showPayOptions"
        cancel-text="取消"
        close-on-click-action>
      <div class="bg-f pd-20 fs-18">
        <div class="c-a fs-14 text-align-center mg-b-30">请选择支付方式</div>
        <div @click="onPaySelectClick('alipay_h5')" class="justify-content-center align-items-center pd-10">
          <img src="/h5/static/images/alipay.png" class="w-20">
          <div class="w-120 text-align-center">支付宝</div>
        </div>
        <!--        <div class="h-1 bg-f3f mg-t-15 mg-b-10"></div>-->
        <!--        <div v-if="!morePayWay"-->
        <!--             class="justify-content-center align-items-center pd-10 mg-t-10">-->
        <!--          <div class="w-200 text-align-center c-6 fs-12">暂不支持其他支付方式</div>-->
        <!--        </div>-->
        <!--        <div v-if="!morePayWay" @click="morePayWay = true"-->
        <!--             class="justify-content-center align-items-center pd-10 mg-t-10">-->
        <!--          <div class="w-200 text-align-center c-6 fs-12">点此使用其他支付方式&gt;&gt;</div>-->
        <!--        </div>-->
        <!--        <template v-else>-->
        <!--          <div @click="onPaySelectClick('wechat')" class="justify-content-center align-items-center pd-10 mg-t-10">-->
        <!--            <img src="/h5/static/images/wechatpay.png" class="w-20">-->
        <!--            <div class="w-120 text-align-center">微信支付</div>-->
        <!--          </div>-->
        <!--        </template>-->
      </div>
    </van-action-sheet>
  </div>
</template>
<script>

import cardItem from '../components/cardItem'
import deckItem from '../components/deckItem'
import cardViewer from "../components/cardViewer";

import request from '../libs/api.request'
import util from '../libs/util'
import storage from "../libs/storage";

export default {
  name: "Card",
  components: {
    cardViewer,
    cardItem,
    deckItem,
  },
  data() {
    return {
      notice: {},
      active: 0,
      activeDid: null,
      allDecks: {},
      isPreview: false,
      showScore: false,
      score: {
        'quality_score': 0,
        'ui_score': 0,
        'is_after_sales': '1',
        'after_sales_score': 0,
        'score_content': '',
      },
      currentCardIndex: 0,//当前点击的卡牌的索引
      currentEditCard: {},
      cardId: this.$route.params.cardId,
      morePayWay: false,
      downloading: false,
      card: {},
      team: null,
      userAvatar: '',
      userNickname: '',
      userOther: [],
      recommend: [],
      coin: 0,
      appCoin: 0,
      selectPackage: 0,
      rechargePackage: [],
      showPublishNotice: false,
      hasImport: false,
      showPayResult: false,
      showAllUnderwayList: false,
      copyPayUrl: '',
      showInputExchangeCode: false,
      showPayOptions: false,
      exchangeCode: "",
      preview: {},
      showAllPreview: false,
      orderType: '',//订单类型  卡牌或者积分
      openFromAppInner: false, //从app复制打开
      canDownload: false,//是否允许非APP内下载免费卡牌
      underwayList: [],
      randomUnderwayTeam: null,
      underwayUsers: 0,
      underwayCountDowner: null,
      showBuyKnow: false,
      buyKnowHtml: '',
      mScrollY: 0,
      showPurchasedExpiredExplain: false,
    }
  },
  computed: {
    formatFileSize() {
      if (this.card.fileSize > 1024 * 1024) {
        return (this.card.fileSize / (1024 * 1024)).toFixed(1) + "MB"
      } else if (this.card.fileSize > 1024) {
        return (this.card.fileSize / (1024)).toFixed(1) + "KB"
      } else {
        return this.card.fileSize + "B"
      }
    },
    purchasedCard() {//已购
      return this.card.owner || this.card.price == 0 || this.card.purchased;
    },
    // 资源更新有效期是否已过期（card.purchasedExpiredDate 格式为 yyyy-MM-dd）
    purchasedExpired() {
      if (!this.card.purchasedExpiredDate) return false;
      const today = new Date();
      const y = today.getFullYear();
      const m = String(today.getMonth() + 1).padStart(2, '0');
      const d = String(today.getDate()).padStart(2, '0');
      const todayStr = `${y}-${m}-${d}`;
      return todayStr > this.card.purchasedExpiredDate;
    },
  },
  watch: {
    $route(to, from) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.cardId = this.$route.params.cardId;
      this.getData();
    },
    isPreview: {
      handler(newVal, oldVal) {
        console.log(newVal, oldVal)
        if (!newVal) {
          if (this.active == 2) {
            this.active = 0;
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    onBuyKnowClick() {
      this.buyKnowHtml = document.getElementById('buyKnow').innerHTML;
      this.showBuyKnow = true;
    },
    subScore() {
      request.request({
        url: '/card/subScore',
        data: {card_id: this.cardId},
        method: 'post'
      }).then((data) => {
        this.showScore = true;
      }).catch((err) => {
        if (err.code === 401 || err.code === 403) {
          this.$parent.login();
          return;
        }
        this.$toast(err.message)
      })
    },
    saveScore() {
      request.request({
        url: '/card/score',
        data: {...{card_id: this.cardId}, ...this.score},
        method: 'post'
      }).then((data) => {
        this.score = {
          'quality_score': 0,
          'ui_score': 0,
          'after_sales_score': 0,
          'score_content': '',
        };
        this.showScore = false;
        this.$toast('评价已提交！');
      }).catch((err) => {
        if (err.code === 401 || err.code === 403) {
          this.$parent.login();
          return;
        }
        this.$toast(err.message)
      })
    },
    toVip() {
      if (!this.$parent.loginUser) {
        this.$parent.login();
      } else {
        if (this.$parent.isIos && this.$parent.appInner) {
          if (util.compareVersionIfMax(this.$parent.appVersion, '1.13.2')) {
            akBridge.callHandler("openVIPPage");
          } else {
            this.$dialog.alert({message: '咦跳不过去了，请返回app设置页面查看详情哦'}).then(() => {
            })
          }
        } else {
          this.$router.push({'path': '/vip', query: {chan: 1}})
        }
      }
    },
    onTeamDetailClick() {
      this.$router.push({'path': '/team/' + this.team.teamId})
    },
    unSupportPlatform() {
      if (
          this.$parent.appInner &&
          this.card.platform.length > 0) {
        let p = this.$parent.isIos ? 2 : 1;
        return this.card.platform.indexOf(p) === -1;
      }

      return false;
    },
    onPaySelectClick(payType) {
      if (this.downloading) {
        return;
      }

      if (payType.indexOf("wechat") > -1) {
        if (util.inWechatPC()) {
          this.$dialog.alert({message: "请使用手机版微信打开链接支付"});
          return;
        }
        payType = util.inWechat() ? 'wechat_gzh' : 'wechat_h5'
      } else if (payType.indexOf("alipay") > -1) {
        // if (util.inWechat()) {
        //   this.$parent.showCommonMask("微信内不支持支付宝", "请打开外部浏览器进行支付");
        //   return;
        // }
      } else {
        this.$dialog.alert({
          message: '错误的支付方式',
        });
      }

      this.downloading = true;
      request.request({
        url: '/card/order',
        data: {
          isMobile: /windows phone|iphone|android/ig.test(window.navigator.userAgent) ? 1 : 0,
          cardId: this.cardId,
          returnUrl: location.href,
          appInner: this.$parent.appInner ? 1 : 0,
          payType: payType,
          orderType: this.orderType,
          wxOpenId: this.$parent.wxOpenId
        },
        method: 'post'
      }).then((data) => {
        this.downloading = false;
        if (this.orderType === 'team') {
          localStorage.setItem("jumpTeamOrder", 1);
        }
        if (util.inWechat()) {
          // if (true) { // 调试代码
          if (payType.indexOf("alipay") > -1) {
            this.copyPayUrl = data.copyPayUrl;
            // 将url 拼接到 # 后面，用户用浏览器打开的时候 会在 mounted 进行判断跳转
            location.href = "?app-token= " + this.$parent.authToken + "#" + encodeURIComponent(data.payUrl);
          } else {
            WeixinJSBridge.invoke('getBrandWCPayRequest', data.payData, (res) => {
              if (res.err_msg === "get_brand_wcpay_request:ok") {
                this.showPayOptions = false;
                this.$toast.loading({message: '正在查询支付结果', duration: 60000, overlay: true});
                setTimeout(() => {
                  location.reload();
                }, 3000);
              }
            });
          }
        } else {
          this.copyPayUrl = data.copyPayUrl;
          if (this.$parent.appInner && this.$parent.isAndroid && util.compareVersionIfMax('3.00.12', this.$parent.appVersion) && payType === 'wechat_h5') {
            this.$dialog.confirm({
              message: '请复制支付链接，然后打开手机浏览器粘贴前往支付',
              confirmButtonText: '复制链接'
            }).then(() => {
              this.$parent.execCopy(this.copyPayUrl, false);
              setTimeout(() => {
                this.$dialog.confirm({message: '链接已复制，请支付成功后点击【确认】刷新页面'}).then(() => {
                  location.reload();
                })
              }, 300)
            })
          } else {
            setTimeout(() => {
              this.showPayResult = true;
              this.showPayOptions = false;
            }, 800);
            location.assign(data.payUrl);
          }
        }
      }).catch((err) => {
        setTimeout(() => {
          this.downloading = false;
        }, 600);
        this.$toast(err.message);
        if (err.code === 401 || err.code === 403) {
          this.$parent.login();
        }
      })

    },
    onPayConfirm() {
      let href = location.href;
      this.$toast.loading({message: '', duration: 8000, overlay: true});
      setTimeout(() => {
        location.replace(href.replace(new RegExp("h5pay_redirect=", "gm"), 'h5pay_redirected='));
      }, 1500);
    },
    onImportAnkiClick() {
      this.$dialog.confirm({
        message: this.card.fileSize > 1024 * 1024 * 500 ? "该文件超过500M下载时间可能较长，若长下载不成功可尝试用电脑浏览器访问【Anki中文资源网】进行下载" : "将要下载文件是否继续？",
        confirmButtonText: '开始下载',
        cancelButtonText: '取消'
      }).then(() => {
        this.onDownloadClick();
      }).catch(() => {
      });
    },
    onPayCancel() {
      let href = location.href;
      location.replace(href.replace(new RegExp("h5pay_redirect=", "gm"), 'h5pay_redirected='));
    },
    onBackClick() {
      this.$router.push({path: '/'});
    },
    onEvaluateClick(val) {
      if (this.$parent.loginUser) {
        request.request({
          url: '/card/evaluate',
          data: {cardId: this.cardId, value: val},
          method: 'post'
        }).then((data) => {
          this.card.evaluateUserCount = data.evaluateUserCount
          this.card.score = data.score
          this.card.evaluated = true
          this.$toast('评价已提交！');
        }).catch((err) => {
          if (err.code === 401 || err.code === 403) {
            this.$parent.login();
            return;
          }
          this.$toast(err.message)
        })
      } else {
        this.$parent.login();
      }
    },
    onTeamOrderClick() {
      if (!this.$parent.loginUser) {
        this.$parent.login();
        return;
      }

      if (this.$parent.appInner && this.$parent.isIos) {
        if (this.appCoin < this.card.teamInfo[0]['vipPrice'] / 100) {
          //弹窗提示，跳转去链接买
          this.$dialog.alert({
            title: '温馨提示',
            closeOnClickOverlay: true,
            showConfirmButton: false,
            message: "暂不支持APP内购买<br><br><a target='_blank' class='c-7 fs-16' href='/h5/card/'" + this.card.cardId + "><span style='color: #0fc669'>长按此处</span>打开外部链接进行购买</a>"
          });
          return;
        }

        try {
          localStorage.setItem("jumpTeamOrder", 1);
          akBridge.callHandler("akOrder", 'team:' + this.cardId + '--ios')
        } catch (e) {
          this.$toast('调起下单失败')
        }
      } else {
        this.orderType = 'team';
        this.showPayOptions = true;
      }
    },
    onDownloadClick(toAnymo) {
      if (!toAnymo && util.inWechat() && this.purchasedCard) {
        this.$parent.showCommonMask("微信内不支持下载", "请通过外部浏览器打开下载");
        return;
      }
      if (!toAnymo && this.$parent.isIos && util.inQQ() && this.purchasedCard) {
        this.$parent.showCommonMask("QQ内不支持下载", "请通过外部浏览器打开下载");
        return;
      }

      if (this.$parent.loginUser) {
        if (this.card.owner || this.card.purchased) {
          this.onRealDownloadClick(toAnymo);
          return;
        }

        if (this.card.price > 0) {
          //判断是否在app内嵌h5
          if (this.$parent.appInner && this.$parent.isIos) {
            if (this.appCoin < this.card.vipPrice / 100) {
              //弹窗提示，跳转去链接买
              this.$dialog.alert({
                title: '温馨提示',
                closeOnClickOverlay: true,
                showConfirmButton: false,
                message: "<a target='_blank' class='c-7 fs-16' href=/h5/card/" + this.card.cardId + ">维护中暂不支持APP内购买<br><br><span style='color: #0fc669'>长按此处</span><br><br>打开外部链接进行购买</a>"
              });
              return;
            }

            this.downloading = true;
            try {
              akBridge.callHandler("akOrder", this.cardId + '--' + (this.$parent.isIos ? 'ios' : 'android'))
            } catch (e) {
              this.$toast('调起下单失败')
            }
          } else {
            this.orderType = 'card';
            this.showPayOptions = true;
          }
        } else {
          this.onRealDownloadClick(toAnymo);
        }
      } else {
        this.$parent.login();
      }
    },
    onRealDownloadClick(toAnymo) {
      if (this.downloading) {
        return;
      }

      this.downloading = true;
      let requestStatus = 0;
      setTimeout(() => {
        if (requestStatus === 0) {
          if (this.card.cardCount > 3000) {
            this.$toast.loading({message: '生成下载链接中，卡片较多请耐心等候~', duration: 90000, overlay: true});
          } else {
            this.$toast.loading({message: '生成下载链接中，请稍候', duration: 60000, overlay: true});
          }
        }
      }, 600);
      var url = '/card/downloadUrl?cardId=' + this.cardId;
      if (this.$parent.appInner) {
        url += '&fromAppInner=1';
      }

      request.request({url: url + '&toAnymo=' + (toAnymo ? 1 : 0)}).then((data) => {
        requestStatus = 1;
        this.$toast.clear();
        this.coin = data.coin;
        this.appCoin = data.appCoin;
        storage.setUserInfo({coin: this.coin});
        this.card.purchased = true;
        this.downloading = false;
        if (data.anymoDownloadToken) {
          this.$dialog.confirm({
            message: '下载口令已生成，点击【复制口令】打开Anymo APP即可自动导入；若您还未下载Anymo APP请点击【下载Anymo】',
            confirmButtonText: '复制口令',
            cancelButtonText: '下载Anymo'
          }).then(() => {
            this.$parent.execCopy(data.anymoDownloadToken, false, () => {
              this.$toast('口令已复制，请打开Anymo APP');
            });
          }).catch(() => {
            this.$parent.execCopy(data.anymoDownloadToken, false, () => {
              if (this.$parent.isIOS) {
                location.href = 'https://apps.apple.com/cn/app/id6499072441';
              } else {
                location.href = 'https://anymoweb.com'
              }
            });
          });

          return;
        }

        setTimeout(() => {
          if (!this.$parent.appInner) {
            this.$toast('准备下载文件');
          }
        }, 500);
        if (this.$parent.appInner && this.$parent.isIos) {
          try {
            akBridge.callHandler("akDownloadCard", {
              url: data.url,
              name: this.card.title
            })
          } catch (e) {
            this.$toast('调起下载失败')
          }
        } else {
          var a = document.createElement('a');
          a.setAttribute('href', data.url);
          a.setAttribute('download', data.filename);
          document.body.appendChild(a);
          a.click();
          setTimeout(() => {
            document.body.removeChild(a)
          }, 400)
        }
      }).catch((err) => {
        requestStatus = 1;
        this.$toast.clear();
        setTimeout(() => {
          this.downloading = false;
        }, 500);

        if (err.code === 401 || err.code === 403) {
          this.$parent.login();
        } else {
          this.$toast(err.message)
        }
      })
    },
    onReportClick() {
      this.$router.push({path: '/report', query: {cardId: this.cardId}})
    },
    onPublishClick() {
      if (this.$parent.appInner && this.$parent.isAndroid) {
        this.showPublishNotice = true;
      } else {
        location.href = '/card/edit/0'
      }
    },
    getData() {
      let requestStatus = 0;
      setTimeout(() => {
        if (requestStatus === 0) {
          this.$toast.loading({message: '', duration: 10000});
        }
      }, 1000);
      request.request({
        url: 'card/detail?cardId=' + this.$route.params.cardId + '&appInner=' + (this.$parent.appInner ? 'yes' : ''),
      }).then(data => {
        requestStatus = 1;
        if (data.team && data.team.status == 1) {
          if (localStorage.getItem("jumpTeamOrder") == '1') {
            this.$router.push({path: '/team/' + data.team.teamId});
            return;
          }
        }

        this.$toast.clear();
        this.userId = data.userId;
        this.userAvatar = data.userAvatar;
        this.userNickname = data.userNickname;
        this.userOther = data.userOther;
        this.recommend = data.recommend;
        this.card = data.card;
        this.team = data.team;
        this.allDecks = data.allDecks;
        this.underwayList = data.underwayList;
        if (this.underwayList && this.underwayList.length > 0) {
          this.randomUnderwayIndex = util.randomNum(0, this.underwayList.length - 1);
        }
        this.underwayUsers = data.underwayUsers;
        this.preview = data.preview;
        document.title = data.card.title;
        document.querySelector('meta[name="keywords"]').setAttribute('content', data.card.title);
        document.querySelector('meta[name="description"]').setAttribute('content', data.card.contentDesc);
        let doAction = sessionStorage.getItem('doAction');
        if (doAction) {
          sessionStorage.removeItem('doAction');
          if (doAction === 'download' || doAction === 'toAnymo') {
            setTimeout(() => {
              if (this.card.purchased) {
                this.onDownloadClick(doAction === 'toAnymo');
              } else if (this.team && this.team.payCount >= this.team.users) {
                this.$dialog.alert({
                  message: '正在验证开团结果，请稍等一会刷新页面重试！',
                });
              }
            }, 500)
          } else if (doAction === 'newTeam') {
            this.onTeamOrderClick();
          }
        }

        if (util.inWechat()) {
          this.$parent.doWxShare(this.card.title, this.card.contentDesc,
              "https://file.ankichinas.cn/h5/card/" + this.cardId,
              "https://file.ankichinas.cn/server/static/image/share-icon.jpg");
        }
      }).catch(err => {
        requestStatus = 1;
        this.$toast.clear();
        this.$toast(err.message)
      })
    },
    onShareClick() {
      let shareData = {
        platform: ["QQ", "WEIXIN", "WEIXIN_CIRCLE", "COPY_LINK"],
        link: "https://file.ankichinas.cn/h5/card/" + this.cardId,
        title: this.card.title,
        desc: this.card.contentDesc,
        thumb: "https://file.ankichinas.cn/server/static/image/share-icon.jpg",//缩略图
      };

      if (akBridge && util.compareVersionIfMax(this.$parent.appVersion, '1.9.32')) {
        akBridge.callHandler("socialShare", JSON.stringify(shareData));
      } else if (typeof AnkiDroidJS !== 'undefined' && util.compareVersionIfMax(this.$parent.appVersion, '3.00.20')) {
        AnkiDroidJS.socialShare(JSON.stringify(shareData));
      } else if (util.inWechat()) {
        this.$parent.showWechatShareMask();
      } else {
        this.$parent.execCopy('https://' + location.host + '/card/' + this.cardId, '链接已复制');
      }
    },
    onCopyPayUrlClick() {
      this.$parent.execCopy(this.copyPayUrl, '链接已复制请前往手机浏览器粘贴支付');
    },
    onUserClick() {
      this.$router.push({path: '/userCenter/' + this.userId})
    },
    onTitleClick() {
      this.$router.push({path: '/'})
    },
    onInputExchangeCodeClick() {
      if (this.$parent.loginUser) {
        this.showInputExchangeCode = true;
      } else {
        this.$parent.login();
      }
    },
    onUnderwayTeamClick(team) {
      this.$router.push({path: '/team/' + team.teamId})
    },
    onConfirmExchangeClick() {
      request.request({
        url: '/card/useExchangeCode',
        method: 'post',
        data: {
          cardId: this.cardId,
          code: this.exchangeCode
        }
      }).then((data) => {
        this.getData();
        this.$dialog.alert({message: '兑换成功，你可以下载卡牌了！'}).then(() => {
        })
      }).catch((data) => {
        this.$toast(data.message);
      })
    },
    onTeamRuleClick() {
      this.$dialog.alert({message: "不同卡牌的拼团时间、成团人数不一，参与拼团时请留意\n\n此卡牌拼团规则：\n" + this.card.teamInfo[0].users + "人成团 / " + this.card.teamInfo[0].timeout + "小时内未成团全额退款\n\n拼团团成功后如因卡牌质量问题，可在3天内向客服申请退款，逾期无法操作"}).then(() => {
      })
    },
    onTabClick(name, title) {
      console.log(name, title)
      if (name == 2) {
        this.isPreview = true;
      }
    },
    previewClose() {
      this.isPreview = false;
      this.active = 0;
    },
    getNotice() {
      let that = this;
      request.request({
        url: '/space.index/notice',
        params: {from: 1},
      }).then((data) => {
        console.log(data);
        that.notice = data;
        that.notice.message = that.notice.message.replace("点击查看详情", "");
      }).catch((e) => {
        console.log(e);
      })
    },
    onClickNotice(url) {
      //window.open(url);
      //this.onClickReadNotice();
      if (this.$parent.isIos && this.$parent.appInner) {
        //that.notice.message = '';
        if (util.compareVersionIfMax(this.$parent.appVersion, '1.13.2')) {
          akBridge.callHandler("openVIPPage");
        } else {
          this.$dialog.alert({message: '咦跳不过去了，请返回app设置页面查看详情哦'}).then(() => {
          })
        }
      } else {
        this.$router.push({'path': '/vip', query: {chan: 2}})
      }
    },
    onClickReadNotice() {
      let that = this;
      request.request({
        url: '/space.index/readNotice',
        params: {},
      }).then((data) => {
        console.log(data)
        setTimeout(function () {
          that.getNotice();
        }, 100);
      }).catch((e) => {
        console.log(e);
      })
    },
    handleScroll() {
      this.mScrollY = window.scrollY;
      console.log(this.mScrollY);
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
    if (this.underwayCountDowner) {
      clearInterval(this.underwayCountDowner);
      this.underwayCountDowner = null;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.getNotice();
    this.openFromAppInner = this.$route.query['fromAppInner'] === 'yes';
    this.getData();
    if (this.$parent.loginUser) {
      this.coin = this.$parent.loginUser.coin;
    }

    // 判断如果不在app内且不在微信内（用户用默认浏览器打开时）
    if (!this.$parent.appInner) {
      var url = location.href;
      // # 号切割，判断是否要跳转支付宝支付
      var arr = url.split('#');
      if (arr.length > 1) {
        var checkAliPay = decodeURIComponent(arr[1]);
        if (checkAliPay.indexOf('alipay') > -1) {
          if (!util.inWechat()) {
            this.$toast.loading({message: '正在启动支付宝支付', duration: 8000, overlay: true});
            setTimeout(() => {
              location.href = checkAliPay;
            }, 300);
          } else {
            this.$dialog.confirm({
              message: '微信内不支持支付宝，请点击当前页面顶部右边的菜单，选择【用默认浏览器打开】进行支付',
              confirmButtonText: '我知道了'
            }).then(() => {
              setTimeout(() => {
                this.$dialog.confirm({message: '请点击当前页面顶部右边的菜单，选择【用默认浏览器打开】进行支付，若您已经支付点击【确认】刷新页面'}).then(() => {
                  location.href = arr[0].split('?')[0];
                })
              }, 300)
            })
          }
        }
      }
    }

    if (this.$parent.authToken) {
      request.request({url: 'user/getCoin',}).then((data) => {
        this.coin = data.coin;
        this.rechargePackage = data.rechargePackage;
      })
      if (this.$parent.appInner && this.$parent.isIos) {
        request.request({url: 'user/getAppCoin',}).then((data) => {
          this.appCoin = data.coin;
        })
      }
    }

    if (akBridge) {
      akBridge.registerHandler("akSetCardStatus", (responseData) => {
        this.hasImport = parseInt(responseData) === 1;
      });

      setTimeout(() => {
        akBridge.callHandler("akGetCardId", this.cardId)
      }, 10);
    }

    if (this.$route.query['h5pay_redirect'] === 'yes') {
      setTimeout(() => {
        this.showPayResult = true;
      }, 100)
    }

    let shareInfo = this.$route.query['share_info'] || sessionStorage.getItem('share_info');
    if (shareInfo) {
      request.request({
        url: '/card/checkDownload',
        params: {
          cardId: this.cardId,
          shareInfo: shareInfo
        }
      }).then((data) => {
        this.canDownload = data.ret;
      })
    }

    if (!this.underwayCountDowner) {
      this.underwayCountDowner = setInterval(() => {
        if (this.underwayList && this.underwayList.length > 0) {
          for (let i = 0; i < this.underwayList.length; i++) {
            this.underwayList[i].countDown--;
            if (this.underwayList[i].countDown <= 0) {
              this.underwayList[i].countDownTxt = '00:00:00';
            } else {
              let H = parseInt(this.underwayList[i].countDown / 3600);
              let countDownH = H < 10 ? '0' + H : H;
              let M = parseInt((this.underwayList[i].countDown % 3600) / 60);
              let countDownM = M < 10 ? '0' + M : M;
              let S = parseInt(this.underwayList[i].countDown % 60);
              let countDownS = S < 10 ? '0' + S : S;
              this.underwayList[i].countDownTxt = countDownH + ':' + countDownM + ':' + countDownS;
            }
          }
        }
      }, 1000);
    }
  }
}


</script>

<style>

#notice {
  background-color: #28BEA0;
  vertical-align: middle;
  /* 设置容器大小 */

  /* 设置两个背景图像 */
  background-image: url('/h5/static/images/home_bg_one.png'), /* 第一个背景图像 */ url('/h5/static/images/home_bg_two.png'); /* 第二个背景图像 */

  /* 设置背景图像的位置 */
  background-position: left top, /* 第一个背景图像的位置 */ right bottom; /* 第二个背景图像的位置 */

  /* 设置背景图像的重复 */
  background-repeat: no-repeat, /* 第一个背景图像不重复 */ no-repeat; /* 第二个背景图像重复 */

  /* 设置背景图像的大小 */
  background-size: auto 26%, /* 第一个背景图像宽度自动，高度100% */ auto 26%; /* 第二个背景图像宽度50%，高度自动 */
}

.safe-bottom {
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

.van-tab {
  font-size: 16px !important;
  font-weight: bold !important;
}

.arrow-div {
  position: relative;
  background-color: #ffffff;
  border: 0px solid #dddddd;
  margin-bottom: 1px;
}

.arrow-div:before {
  content: "";
  position: absolute;
  width: 5px;
  height: 5px;
  border: 1px solid #ddd;
  border-color: transparent #ddd #ddd transparent;
  transform: rotate(45deg);
  right: 30px;
  bottom: -4px;
  background: #fff;
}

.card-content iframe {
  width: 100%;
  min-height: 350px;
}
</style>
